export default __webpack_public_path__ + "static/media/food09.76178761.png";